import { client } from "../client";
import * as path from "../paths";
export const forgotPassword = (email) => {
  return client
    .post(path.FORGOT_PASSWORD, { email })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const getAllProfiles = () => {
  return client
    .get(path.GET_ALL_PROFILES)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getNewUsers = () => {
  return client
    .get(path.GET_NEW_USERS)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getCurrentProfile = () => {
  return client
    .get(path.GET_CURRENT_PROFILE)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getProfileByUsername = (username) => {
  return client
    .get(path.GET_PROFILE_USERNAME + username)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const followByUsername = (username) => {
  return client
    .post(path.FOLLOW_NAME + username)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const unFollowUsername = (username) => {
  return client
    .patch(path.UNFOLLOW_NAME + username)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const uploadAvatar = (avatar) => {
  return client
    .post(path.UPLOAD_AVATAR, avatar)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const uploadBanner = (banner) => {
  return client
    .post(path.UPLOAD_BANNER, banner)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const updateProfile = (formData) => {
  return client
    .post(path.UPDATE_PROFILE, formData)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getBookmarks = () => {
  return client
    .get(path.GET_BOOKMARK)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const addBookmark = (id) => {
  return client
    .post(path.ADD_BOOKMARK + id)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const removeBookmark = (id) => {
  return client
    .patch(path.REMOVE_BOOKMARK + id)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const deleteUser = (username) => {
  return client
    .delete(path.DELETE_USER, { data: { username } })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const verifyEmail = (data) => {
  return client
    .post(path.VERIFY_EMAIL, data)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const markNotificationsRead = () => {
  return client
    .patch(path.MARK_NOTIFICATIONS_READ)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const suspendUser = (username) => {
  return client
    .patch(path.SUSPEND_USER, { username })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const deleteMe = (password) => {
  return client
    .delete(path.DELETE_ME, { data: { password } })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const updateUsername = (username) => {
  return client
    .put(path.UPDATE_USERNAME, { username })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const blockUser = (username) => {
  return client
    .patch(path.BLOCK_USER, { username })
    .then((result) => result)
    .catch((err) => err.response);
};

export const unblockUser = (username) => {
  return client
    .patch(path.UNBLOCK_USER, { username })
    .then((result) => result)
    .catch((err) => err.response);
};

